import { combineReducers } from 'redux'
import auth from './auth'
import appUser from './appUser'
import material from './material'
import barcodeProduct from './barcodeProduct'
import hero from './hero'
import heroLink from './heroLink'
import heroNews from './heroNews'
import news from './news'
import banners from './banners'
import coin from './coin'
import category from './category'
import brand from './brand'
import user from './user'
import productFeature from './productFeature'
import document from './document'
import reports from './reports'
import bin from './bin'
import appConfig from './appConfig'
import brandActivity from './brandActivity'
import brandNews from './brandNews'
import brandCover from './brandCover'
import location from './location'
import userAnnouncement from './userAnnouncement'
import heroPromote from './heroPromote'
import heroGroupSelling from './heroGroupSelling'
import heroTurck from './heroTurck'
import reward from './reward'
import equipment from './equipment'
import preset from './preset'
import step from './step'
import bank from './bank'
import remark from './remark'
import appVersion from './appVersion'
import reportProblem from './reportProblem'
import notification from './notification'
import loma from './loma'
import pdpa from './pdpa'
import packege from './package'
import subscriptionPackage from './subscriptionPackage'
import plan from './plan'
import subscriptionPlan from './subscriptionPlan'
import priceDashboard from './priceDashboard'
import priceManagement from './priceManagement'
import priceGroup from './priceGroup'
import priceSchedule from './priceSchedule'
import customerTag from './customerTag'
import apiPartner from './apiPartner'
import tierFeature from './tierFeature'
import priceGroupTierAccess from './priceGroupTierAccess'
import materialAlias from './materialAlias'
import materialCustom from './materialCustom'

export default combineReducers({
  auth,
  appVersion,
  appConfig,
  appUser,
  brand,
  brandActivity,
  brandNews,
  brandCover,
  bin,
  category,
  material,
  heroPromote,
  barcodeProduct,
  reports,
  hero,
  heroNews,
  heroLink,
  heroGroupSelling,
  heroTurck,
  reward,
  equipment,
  preset,
  step,
  bank,
  remark,
  news,
  banners,
  document,
  coin,
  user,
  loma,
  pdpa,
  productFeature,
  location,
  userAnnouncement,
  reportProblem,
  notification,
  packege,
  subscriptionPackage,
  plan,
  subscriptionPlan,
  priceDashboard,
  priceManagement,
  priceGroup,
  priceSchedule,
  customerTag,
  apiPartner,
  tierFeature,
  priceGroupTierAccess,
  materialAlias,
  materialCustom
})
